import { BUILD_ID } from '../generated/buildInfo';
import { isAppBusy } from './workState';

const CHECK_INTERVAL_MS = 60_000;
const MIN_CHECK_GAP_MS = 15_000;
const RELOAD_ATTEMPT_KEY = 'makermargin:last-version-reload';

let lastCheckedAt = 0;
let intervalId;
let stopped = false;

async function checkForNewVersion() {
  if (stopped || document.visibilityState === 'hidden' || isAppBusy()) return;

  const now = Date.now();
  if (now - lastCheckedAt < MIN_CHECK_GAP_MS) return;
  lastCheckedAt = now;

  try {
    const response = await fetch(`/version.json?t=${now}`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) return;
    const latest = await response.json();
    if (!latest?.buildId || latest.buildId === BUILD_ID) return;
    if (isAppBusy()) return;

    const previousAttempt = sessionStorage.getItem(RELOAD_ATTEMPT_KEY);
    if (previousAttempt === latest.buildId) return;

    sessionStorage.setItem(RELOAD_ATTEMPT_KEY, latest.buildId);
    window.location.reload();
  } catch {
    // Network interruptions should never disrupt the user. The next check retries silently.
  }
}

export function startSilentVersionRefresh() {
  if (import.meta.env.DEV || typeof window === 'undefined') return () => {};

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') checkForNewVersion();
  };
  const onFocus = () => checkForNewVersion();
  const onOnline = () => checkForNewVersion();

  window.addEventListener('focus', onFocus);
  window.addEventListener('online', onOnline);
  document.addEventListener('visibilitychange', onVisibilityChange);

  intervalId = window.setInterval(checkForNewVersion, CHECK_INTERVAL_MS);
  window.setTimeout(checkForNewVersion, 4_000);

  return () => {
    stopped = true;
    window.clearInterval(intervalId);
    window.removeEventListener('focus', onFocus);
    window.removeEventListener('online', onOnline);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
}
